<template>
  <div class='view'>
    <top-nav @menu_data="getMenuData" />
    <div class="blank70"></div>
    <div class="features">
      <div class="top_img">
        <img src="../../assets/imgs/app/feature/feature1.png" alt="">
      </div>
      <div class="all_feature_for_needs">
        <div class="titles">All of the features you need</div>
        <div class="sub_title1">Arcanite offers everything you need for project marketing.</div>
        <div class="sub_title2">
          <span class="available_for">Available for:</span>
          <img src="../../assets/imgs/pc/feature/apple.png" alt="">
          <img src="../../assets/imgs/pc/feature/android.png" alt="">
          <img src="../../assets/imgs/pc/feature/computer.png" alt="">
        </div>
        <div class="item_btn">
          <!-- <div class="btn">Login</div> -->
          <!--  -->
          <div @click="handleDemoBooking(true)" class="btn sign_btn">
            <span>Book A Demo</span>
            <img src="./../../assets/imgs/pc/homepage/p12Vector.png" alt="">
          </div>
        </div>
      </div>

      <div class="part2RecoginizedIcons">
        <div class="part2-topcontent">
          <trusted></trusted>
        </div>
        <div class="part2-bottomcontent">
            <recognised></recognised>
        </div>
      </div>

      <div class="our_features">
        <div class="titles">
          Our <br/>Features
        </div>
        <div class="feature_item" v-for="(d,i) in feature_contents" :key="i">
          <div class="icon_img">
            <img :src="d.img" alt="">
          </div>
          <div class="item_titles">
            {{d.title}}
          </div>
          <div class="item_contents">
            {{d.content}}
          </div>
        </div>
      </div>
      <div class="book_a_demos">
        <img src="@/assets/imgs/app/feature/book_a_demo.png" alt="">
        <p>Explore more exclusive features for you</p>
        <div class="book_a_demo">
          <span class="book_a_demo_content" @click="handleDemoBooking(true)">Book A Demo</span>
          <span class="arrow_right"><img src="../../assets/imgs/pc/homepage/p12Vector.png" alt=""></span>
        </div>
      </div>
    </div>
    <book-demo v-if="showBookingDialog" :show="showBookingDialog" @update:show="handleDemoBooking"></book-demo>
		<footer-nav />
    <footer-nav />
    <menu-bar :isShow="isShow" @changeIsShow="changeShow" />
  </div>
</template>

<script>
export default {
  components: {
    "top-nav": resolve => require(["./TopNav.vue"], resolve),
    "footer-nav": resolve => require(["./FooterNav.vue"], resolve),
    "menu-bar": resolve => require(["./MenuBar.vue"], resolve),
    "trusted":(resolve) => require(["./Trusted.vue"], resolve),
    "recognised":(resolve) => require(["./Recognised.vue"], resolve),
    "book-demo": () => import("./BookDemo/Index.vue")
  },
  created(){
    if(localStorage.getItem('country')=="id"){
      this.isID=true;
    }else{
      this.isID=false;
    }
  },
  data() {
    return {
      isID:false,
      isShow: false,
      showBookingDialog: false,
      feature_contents: [
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon1_1.png"),
          title: "Arcanite App delivers property updates instantly",
          content: "Users can search, favourite, and save properties on their mobile devices with ease. Deliver real-time property updates to your leads instantly with push notifications.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon1_2.png"),
          title: "Get access to exclusive Arcanite products",
          content: "Gain access to virtual reality property rendering technology, exclusive minimal deposit finance products and marketplaces to increase project marketing connections.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon1_3.png"),
          title: "Instant file sharing from mobile devices",
          content: "Share QR codes with links to client contact forms and VR property walk-throughs, via the Arcanite App. Instantly generate marketing brochures displaying property images and specifications, with your own company branding.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon2_1.png"),
          title: "Access all customer information in one app",
          content: "Track customer activity and receive a chronological timeline review of all customer engagements. Add notes, tasks, and appointments to each customer’s profile.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon2_2.png"),
          title: "Prioritise your most valuable leads",
          content: "Focus on leads with the highest follow-through potential and store customer preferences for fast lead generation for upcoming projects.",
        }, {
          img: require("@/assets/imgs/pc/feature/feature_item_icon2_3.png"),
          title: "Automated workflows for time saving benefits",
          content: "Let Arcanite take care of time-consuming, tedious tasks. Arcanite’s automated system is created to handle a wide range of repetitive tasks, minus the element of human error. This will free your most precious resource - your agents’ time and attention, to focus on generating leads and making deals happen.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon3_1.png"),
          title: "Analyse how your business is performing",
          content: "Arcanite’s dashboard generates weekly, monthly, and yearly sales reports to identify gaps in performance and create data files. Data metrics are key in company decision-making processes and Arcanite’s software draws out strategies from this input, to continue to grow your business further.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon3_2.png"),
          title: "Effectively manage your company",
          content: "Set up your Arcanite dashboard to work specifically for your company. Establish team and data management settings that work across the entire platform. Determine what information your team members can view from their front-end Arcanite App.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon3_3.png"),
          title: "The Arcanite team is here to support you",
          content: "Access training material and an extensive list of FAQ’s on the Arcanite App, enabling quick adaptability for all users. Arcanite provides an online support network, digital identity set-up options and additional project update support is available, providing considerable time and money savings.",
        },
        {
          img: require("@/assets/imgs/pc/feature/feature_item_icon4_1.png"),
          title: "Highly compatible with real estate CRM systems",
          content: "Arcanite has the ability to sync with most real estate and generic CRM platforms, as well as other software systems which your company relies on, such as Mailchimp, Zapier, Twilio, Stripe, etc.",
        },
		{
		  img: require("@/assets/imgs/pc/feature/feature_item_icon5_1.png"),
		  title: "Customise to suit your specific needs",
		  content: "Choose from a variety of subscriptions with inclusions to suit your corporation’s operational needs. Customise how you view your projects and integrate additional systems used by your company, creating a comprehensive and centralised space for all workflows.",
		}
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {
    getMenuData(val) {
      val == "1" ? (this.isShow = true) : (this.isShow = false);
    },
    changeShow() {
      this.isShow = false;
    },      
    handleDemoBooking(open = false) {
      const base = this.$route.path.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      if (open) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } else {
        history.replaceState({}, '', base || '/');
      }
      this.showBookingDialog = open;
    },
    // showPopupWidget() {
    //   if(this.isID){
    //     Calendly.showPopupWidget('https://calendly.com/erni-yap');
    //   }else{
    //     Calendly.showPopupWidget('https://meetings.hubspot.com/william463?embed=true');
    //   }
    //   return false;
    // }
  },
}
</script>
<style lang='scss' scoped>
.view {
  // background-color: #f8f8f8;
  width: 100vw;
  .blank70 {
    height: 70px;
  }
  .features {
    margin:auto;
    max-width: 428px;
    min-width:320px ;
    padding-top: 42px;
    background-color: #fff;
    .top_img {
      // height: 376px;
      max-width:429px;
      min-width: 320px;
      img {
        // height: 100%;
        width: 100%;
      }
    }
    .all_feature_for_needs {
      padding-top: 42px;
      .titles {
        padding-left: 26px;
        padding-right: 26px;
        font-family: Poppins-Bold;
        font-size: 30px;
        // font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #062440;
      }
      .sub_title1 {
        margin-top: 10px;
        padding-left: 26px;
        padding-right: 26px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #314455;
      }
      .sub_title2 {
        margin-top: 10px;
        display: flex;
        padding-left: 26px;
        .available_for {
          font-family: Poppins;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: #062440;
        }
        img {
          width: 18px;
          height: 18px;
          margin:0 3px 0 3px;
        }
      }
      .item_btn {
        margin-top: 20px;
        padding-left: 26px;
        padding-right: 26px;
        display: flex;
        .btn {
          width: 175px;
          height: 42px;
          border: 1px solid #1890ff;
          border-radius: 5px;
          font-family: Poppins-Bold;
          font-size: 16px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 42px;
          letter-spacing: normal;
          text-align: center;
          color: #1890ff;
        }
        .sign_btn {
          // margin-left: 20px;
          background-color: #1890ff;

          display: flex;
          align-items: center;
          span {
            font-family: Poppins-Bold;
            font-size: 16px;
            // font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 42px;
            letter-spacing: normal;
            text-align: center;
            color: #fff;
            margin-left: 16px;
          }
          img {
            width: 22px;
            height: 22px;
            margin-left: 10px;
          }
        }
      }
    }
    .our_features {
      padding-top: 100px;
      padding-left: 26px;
      .titles {
        font-family: Poppins-Bold;
        font-size: 36px;
        // font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: normal;
        text-align: left;
        color: #062440;
      }
      .feature_item {
        margin-top: 34px;
        padding-right: 26px;
        .icon_img {
          text-align: left;
          img {
            margin-top: 10px;
            width: 36px;
            height: 36px;
          }
        }

        .item_titles {
          margin-top: 10px;
          font-family: Poppins-Bold;
          font-size: 16px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.38;
          letter-spacing: normal;
          text-align: left;
          color: #062440;
        }
        .item_contents {
          margin-top: 10px;
          font-family: Poppins;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: left;
          color: #314455;
        }
      }
    }
    .book_a_demos {
      padding: 0;
      margin:auto;
      margin-top: 50px;
      width: 100vw;
      position: relative;
      max-width: 428px;
      text-align: center;
      line-height: 0;
      // background: url("../../assets/imgs/app/feature/book_a_demo.png") no-repeat center center;
      img {
        width: 100%;
        max-width: 428px;
        margin:auto;
      }
      p {
        padding-right: 26px;
        font-family: Poppins-Bold;
        font-size: 26px;
        // font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        position: absolute;
        top: 26px;
        left: 26px;
      }
      .book_a_demo {
        position: absolute;
        bottom: 26px;
        width: 171px;
        height: 42px;
        left: 26px;
        display: flex;
        background-color: #062440;
        border-radius: 5px;
        align-items: center;
        .book_a_demo_content {
          margin-left: 16px;
          font-family: Poppins-Bold;
          font-size: 16px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.38;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
        }
        .arrow_right {
          margin-left: 10px;
          width: 22px;
          height: 22px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}

.part2RecoginizedIcons{
  margin: 40px auto;
  // width: 1210px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items:center;
  gap: 30px;
}
</style>